/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCardSkin} from '../api'

 export const useQueryGetCardSkin = createReactQueryHook('getCardSkin', getCardSkin)
